module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/6th/mainvisual-bg-right_ba06ee0e5ec30879669fdb691610197f.svg";